import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AccountActivationBaseMessage
  from '@/views/overseasSales/customerCenter/accountActivation/components/DetailForm.vue'
import { newClientEvaluationDetail, newClientEvaluationReviewHistory } from '@/api/overseasSales/newClientEvaluation'

const __default__ = { name: 'DcCosOFbuAccountActivationDetail' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.accountActivationId) {
    newClientEvaluationDetail({ id: route.query.accountActivationId as unknown as number }).then((res) => {
      if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
        res.data.business.businessTypeSelect = res.data.business.businessType[0]
      }
      data.value = res.data
    })
  }
}
const reviewHistory = ref<any[]>([])
const fetchReviewHistory = async () => {
  const res = await newClientEvaluationReviewHistory({ id: route.query.accountActivationId as unknown as number })
  reviewHistory.value = res.data
}
const permissionBasic = {
  save: 'ofbu_potential_edit_btn',
  editCode: 'ofbu_potential_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
  fetchReviewHistory()
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(AccountActivationBaseMessage, {
            disabled: true,
            formItemView: "",
            permissionPage: permissionBasic,
            data: data.value,
            reviewHistory: reviewHistory.value
          }, null, 8, ["data", "reviewHistory"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})